export default __webpack_public_path__ + "static/media/exit.d83a5c5b.svg";